/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type DrawerPlacement = "top" | "bottom" | "left" | "right";

interface AllCommonDrawerState {
    isOpen: boolean;
    componentName: string | null | undefined;
    data?: any;
    placement: DrawerPlacement;
    className?: string;
}

interface OpenDrawerPayload {
    componentName: string;
    data?: any;
    placement?: DrawerPlacement;
    className?: string;
}

const initialState: AllCommonDrawerState = {
    isOpen: false,
    componentName: null,
    data: null,
    placement: "right",
    className: '',
};

const allCommonDrawerSlice = createSlice({
    name: "allCommonDrawer",
    initialState,
    reducers: {
        openDrawer: (state, action: PayloadAction<OpenDrawerPayload>) => {
            state.isOpen = true;
            state.componentName = action.payload.componentName;
            state.data = action.payload.data;
            state.placement = action.payload.placement ?? "right";
            state.className = action.payload.className;
        },
        closeDrawer: (state) => {
            state.isOpen = false;
            state.componentName = null;
            state.data = null;
        },
    },
});

export const { openDrawer, closeDrawer } = allCommonDrawerSlice.actions;
export default allCommonDrawerSlice.reducer;
